<div class="settings-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12 settings-page__content">
                <div class="settings-card">
                    <div class="settings-card__header">
                        <img src="/assets/images/Group 24.svg" alt="" />
                        <div class="settings-card__header-headline">
                            <h4>Rapoarte Activitate</h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Rapoarte Activitate</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="searchRapoarte()">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.export')"
                                type="button" class="btn btn-sm btn-warning pull-right ms-1" (click)="exportFile(1)">
                                <i class="fa fa-download"></i>
                                Export CSV
                            </button>
                            <button *ngIf="permissionsService.hasPermission('indoc-module.rapoarte-activitati.export')"
                                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="exportFile(2)">
                                <i class="fa fa-download"></i>
                                Export PDF
                            </button>
                        </div>
                    </div>

                    <div class="p-3">
                        <form [formGroup]="form">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="divider-container mb-2">
                                        <div class="line"></div>
                                        <span class="text">ORIGINE/OPERATOR</span>
                                        <div class="line"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Instituție/Direcție</mat-label>
                                                <input matInput [formControl]="directiiOriginControl"
                                                    [matAutocomplete]="autoDirectiiOrigin"
                                                    (blur)="onDirectiiOriginBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoDirectiiOrigin="matAutocomplete"
                                                    [displayWith]="displayDirectiiOrigin"
                                                    (optionSelected)="onDirectiiOriginChange($event.option.value)">
                                                    <mat-option *ngIf="filteredDirectiiOrigin.length === 0" disabled>
                                                        Nu au fost găsite rezultate
                                                    </mat-option>
                                                    <mat-option *ngFor="let directie of filteredDirectiiOrigin"
                                                        [value]="directie">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Compartiment/Departament</mat-label>
                                                <input matInput [formControl]="compartimenteOriginControl"
                                                    [matAutocomplete]="autoCompartimenteOrigin"
                                                    (blur)="onCompartimenteOriginBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoCompartimenteOrigin="matAutocomplete"
                                                    [displayWith]="displayCompartimenteOrigin"
                                                    (optionSelected)="onCompartimenteOriginSelected($event.option.value)">
                                                    <mat-option *ngIf="showCompartimenteOriginMessage" disabled>
                                                        <span
                                                            *ngIf="!compartimenteOriginControl.value || compartimenteOriginControl.value.length < 2">
                                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                                        </span>
                                                        <span
                                                            *ngIf="isCompartimenteOriginLoading && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">Căutare...</span>
                                                        <span
                                                            *ngIf="!isCompartimenteOriginLoading && compartimenteOriginLoadComplete && compartimenteOrigin.length === 0 && compartimenteOriginControl.value && compartimenteOriginControl.value.length >= 2">
                                                            Nu au fost găsite rezultate
                                                        </span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of compartimenteOrigin"
                                                        [value]="compartiment">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Operator</mat-label>
                                            <mat-select formControlName="origin_user_id"
                                                (selectionChange)="onOperatoriOriginChange($event.value)">
                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let operator of filteredOperatoriOrigin"
                                                    [value]="operator.id">
                                                    {{ operator.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="divider-container mb-2">
                                        <div class="line"></div>
                                        <span class="text">DESTINAȚIE</span>
                                        <div class="line"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Instituție/Direcție</mat-label>
                                                <input matInput [formControl]="directiiDestinatieControl"
                                                    [matAutocomplete]="autoDirectiiDestinatie"
                                                    (blur)="onDirectiiDestinatieBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                                                    [displayWith]="displayDirectiiDestinatie"
                                                    (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                                                    <mat-option *ngIf="filteredDirectiiDestinatie.length === 0"
                                                        disabled>
                                                        Nu au fost găsite rezultate
                                                    </mat-option>
                                                    <mat-option *ngFor="let directie of filteredDirectiiDestinatie"
                                                        [value]="directie">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Compartiment/Departament</mat-label>
                                                <input matInput [formControl]="compartimenteDestinatieControl"
                                                    [matAutocomplete]="autoCompartimenteDestinatie"
                                                    (blur)="onCompartimenteDestinatieBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                                                    [displayWith]="displayCompartimenteDestinatie"
                                                    (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                                                    <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                                        <span
                                                            *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                                        </span>
                                                        <span
                                                            *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                                        <span
                                                            *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                                            Nu au fost găsite rezultate
                                                        </span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of compartimenteDestinatie"
                                                        [value]="compartiment">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Operator</mat-label>
                                                <mat-select formControlName="destinatie_user_id"
                                                    (selectionChange)="onOperatoriDestinatieChange($event.value)">
                                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                    <mat-option *ngFor="let operator of filteredOperatoriDestinatie"
                                                        [value]="operator.id">
                                                        {{ operator.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="divider-container mb-2">
                                <div class="line"></div>
                                <span class="text">IDENTIFICARE DOCUMENT(E)</span>
                                <div class="line"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field>
                                        <mat-label>Număr Document(Intrare/Intern)</mat-label>
                                        <input matInput type="number" formControlName="document_number" />
                                        <!-- <mat-hint><i>Căutarea unui document specific (filtru aplicat
                                                individual)</i></mat-hint> -->
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) de la:</mat-label>
                                        <input matInput [max]="today" [matDatepicker]="dateInputStartPicker"
                                            formControlName="date_input_start" readonly
                                            (focus)="dateInputStartPicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateInputStartPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateInputStartPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field>
                                        <mat-label>Dată Document(e) până la:</mat-label>
                                        <input matInput [min]="form.get('date_input_start')?.value"
                                            [matDatepicker]="dateInputEndPicker" formControlName="date_input_end"
                                            readonly (focus)="dateInputEndPicker.open()" />
                                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix
                                            [for]="dateInputEndPicker"></mat-datepicker-toggle>
                                        <mat-datepicker #dateInputEndPicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="divider-container mb-2">
                                <div class="line"></div>
                                <span class="text">TIP RAPORT</span>
                                <div class="line"></div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Registru/Serie</mat-label>
                                        <mat-select formControlName="id_serie">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let serie of registreActiveSwitch" [value]="serie.id">
                                                {{ serie.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Tip raport</mat-label>
                                        <mat-select formControlName="registru_type">
                                            <mat-option *ngFor="let tip of tipRapoarte" [value]="tip.id">
                                                {{ tip.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>

                        <div class="row mb-3">
                            <div class="col-md-4">
                                <button type="button" (click)="resetForm()" class="btn-general w-100"
                                    style="background-color: #3c8dbc; border-color: #367fa9; color: #fff;">
                                    <i class="fa fa-refresh"></i>
                                    <span>Resetează Filtre</span>
                                </button>
                            </div>
                            <div class="col-md-8">
                                <button type="button" (click)="searchRapoarte()" class="btn-general w-100"
                                    style="background-color: #00a65a;  border-color: #008d4c; color: #fff;">
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <span>Afișare</span>
                                </button>
                            </div>
                        </div>

                        <table class="table table-condensed">
                            <thead>
                                <tr>
                                    <th>Crt.</th>
                                    <th>Selecție</th>
                                    <th>Intrări</th>
                                    <th>Finalizate</th>
                                    <th>Ieșiri Oficiu</th>
                                    <th>Interne (posibile ieșiri)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of rapoarteList; let i = index">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ row.selection }}</td>
                                    <td>{{ row.summary.nr_intrari }}</td>
                                    <td>{{ row.summary.nr_raspunsuri_finalizate }}</td>
                                    <td>{{ row.summary.nr_iesiri_din_oficiu }}</td>
                                    <td>{{ row.summary.nr_lucrari_interne }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>